<div class="button-wrapper">
    <div class="container">
        <div class="buttons">
            @if (activePage() !== 'formulier') {
                <button
                    class="planning-button"
                    [class.active]="activePage() === 'formulier'"
                    [routerLink]="['/dagrapport', planning()?.id, 'formulier']"
                    [disabled]="navigationDisabled()"
                    color="primary"
                    mat-raised-button>
                    <i class="far fa-file-lines"></i>
                    <span class="btn-label">Formulier</span>
                </button>
            }

            @if (activePage() !== 'productie') {
                <button
                    class="planning-button"
                    [class.active]="activePage() === 'productie'"
                    [routerLink]="['/dagrapport', planning()?.id, 'productie']"
                    [disabled]="navigationDisabled()"
                    color="primary"
                    mat-raised-button>
                    <i class="far fa-brush"></i>
                    <span class="btn-label">Productie</span>
                </button>
            }

            @if (activePage() !== 'urenregistratie') {
                <button
                    class="planning-button"
                    [class.active]="activePage() === 'urenregistratie'"
                    [routerLink]="['/dagrapport', planning()?.id, 'urenregistratie']"
                    [disabled]="navigationDisabled()"
                    color="primary"
                    mat-raised-button>
                    <i class="far fa-clock"></i>
                    <span class="btn-label">Urenregistratie</span>
                </button>
            }

            <div class="settings-menu">
                <app-settings-menu
                    [projectId]="planning()?.afas_project_id"
                    [date]="planning()?.mainPlanning?.begindate" />
            </div>

            @if (showActionButton()) {
                <button
                    class="planning-button"
                    [disabled]="actionButtonDisabled()"
                    (click)="onActionButtonClick()"
                    mat-raised-button
                    color="primary">
                    @if (actionButtonIcon()) {
                        <i [class]="actionButtonIcon()"></i>
                    }
                    <span class="btn-label">{{ actionButtonText() }}</span>
                </button>
            }
        </div>
    </div>
</div>
